(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'app/urls', 'torso/modules/Collection', 'torso/modules/NestedModel'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('jquery'), require('./../urls'), require('backbone-torso/modules/Collection'), require('backbone-torso/modules/NestedModel'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function ($, urls, TorsoCollection, TorsoNestedModel) {
  'use strict';
  var specificAppointmentFeatureConfigService = urls.specificAppointmentFeatureConfigService;
  /**
   * @class SpecificAppointmentFeatureConfigCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: TorsoNestedModel,
    url: specificAppointmentFeatureConfigService,
    fetchHttpAction: 'POST',

    /**
     * @method fetchByCriteria
     * @param criteria {Object} criteria to fetch by
     *   @param criteria.externalAppointment {Object} Wrapper object because our API is weird
     *     @param [criteria.externalAppointment.type] {String} Appointment type
     *     @param [criteria.externalAppointment.externalClinicId] {String} Appointment external clinic id
     *     @param [criteria.externalAppointment.clinicName] {String} Appointment external clinic name
     */
    fetchByCriteria: function(criteria) {
      return $.ajax({
        url: specificAppointmentFeatureConfigService,
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(criteria)
      }).then(function(response) {
        return new TorsoNestedModel(response);
      });
    }
  }))();
}));
